import React, { useState, useEffect } from 'react'
import { GetDetail, PostInside, Update, ImageURL } from '../../web_api/api'
import { useLocation } from 'react-router-dom'
import { FaImages } from "react-icons/fa";
import 'react-photo-view/dist/react-photo-view.css';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { Link } from 'react-router-dom';
export default function TreatmentCreate() {
    //to get main id
    const location = useLocation()
    const ID = location.pathname.split('/')[2]

    //fields name
    const [name, setName] = useState('')
    const [title, setTitle] = useState('')
    const [description, setDescription] = useState('')
    const [type, setType] = useState('')
    const [descriptionList, setDescriptionList] = useState([])
    const [image, setImage] = useState([])
    const [addSection, setAddSection] = useState([])
    const [showNextSection, setShowNextSection] = useState(false)
    const [showNextImage, setShowNextImage] = useState(false)

    //NOTE Input Changes when input values
    const handleInputChange = (event, id, field) => {
        const newData = addSection.map(data => {
            if (data.id === id) {
                return { ...data, [field]: event.target.value }
            }
            return data
        })
        setAddSection(newData)
    }



    const AddSection = () => {
        setAddSection([
            ...addSection,
            {
                title: title,
                description: description
            }
        ])
        setShowNextSection(true)
    }

    const ImageAddSection = (e) => {
        setImage([
            ...image,
            {
                blog: e.target.files[0],
            }
        ])
        setShowNextImage(true)
    }

    const create = async () => {
        const sectionData = JSON.stringify(addSection)
        const formData = new FormData()
        formData.append('name', name)
        formData.append('type', type)
        image.map((item) => (
            formData.append('blog', item.blog)
        ))
        formData.append('datas', sectionData)

        await Update('/blog/', ID, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    }

    const handleOneUpdate = async (item) => {
        const formData = new FormData()
        image.map((item) => (
            formData.append('blog', item.blog)
        ))
        formData.append('description', item.description)
        formData.append('title', item.title)
        await Update('/blog-update/', item._id, formData, { headers: { 'Content-Type': 'multipart/form-data' } })

    }

    const handleOneAdd = async (item) => {

        const formData = new FormData()
        image.map((item) => (
            formData.append('blog', item.blog)
        ))

        formData.append('description', item.description)
        formData.append('title', item.title)
        await PostInside('/blog/', ID, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    }


    useEffect(() => {
        const getData = async () => {
            const res = await GetDetail('blog/', ID)
            setName(res.data.name)
            setType(res.data.type)
            setDescriptionList(res.data.relatedDescription)
            setAddSection(res.data.relatedDescription)
            setImage(res.data.relatedDescription.map((i) => (i.imageUrl)))

        }

        getData()
    }, [])

    return (
        <div>
            <div>
                <div>
                    <label for='#tn'>Treatment Name</label>
                    <input type='text' id='tn' placeholder='Teatment Name' className='form-control' value={name} onChange={(e) => setName(e.target.value)} />
                </div>
                <div>
                    <label for='#tn'>Treatment Type</label>
                    <select className='form-control' onChange={(e) => setType(e.target.value)}>
                        <option hidden>{(type === 'face' ? 'Face & Skin' : (type === 'body' ? 'Body Contouring' : type === 'dental' ? 'Dental Care' : 'Choose Type ...'))}</option>
                        <option value='face'>Face & Skin</option>
                        <option value='body'>Body Contouring </option>
                        <option value='dental'>Dental Care</option>
                    </select>
                </div>
                {descriptionList ? (
                    <>
                        {addSection.map((item, index) => (
                            <div className='border-1 border-info rounded-1 border p-3 mt-2'>
                                <h3 className='text-decoration-underline'>Tretment Detail Section {index + 1}</h3>
                                <div>
                                    <label for='#tn'>Title </label>
                                    <input type='text' id='tn' placeholder='Title' className='form-control' value={item.title} onChange={(e) => handleInputChange(e, item.id, 'title')} />
                                </div>
                                <div className='row'>
                                    <div className='col-8'>
                                        <label for='#tn'>Image </label>
                                        <input type='file' id='tn' className='form-control' onChange={(e) => ImageAddSection(e)} />
                                    </div>

                                    <div className='col-3 '>
                                        {/* To view fullscreen for image */}
                                        <PhotoProvider>
                                            <PhotoView key={index} src={ImageURL + item.imageUrl}>
                                                <abbr title='Click View' className={item.imageUrl ? 'text-blue' : ''}>
                                                    <FaImages style={{ width: '50px', height: '100px' }} />
                                                </abbr>
                                            </PhotoView>
                                        </PhotoProvider >

                                    </div>

                                </div>
                                <div>
                                    <label for='#tn'>Description </label>
                                    <textarea type='text' id='tn' placeholder='Write description ...' defaultValue={item.description} className='form-control' onChange={(e) => handleInputChange(e, item.id, 'description')} />
                                </div>
                                {!item._id ? (
                                    <div className='mt-3 text-end'>
                                        <button className='btn btn-sm btn-success rounded-2' onClick={() => handleOneAdd(item)}>Add</button>
                                    </div>
                                ) : (
                                    <div className='mt-3 text-end'>
                                        <button className='btn btn-sm btn-primary rounded-2' onClick={() => handleOneUpdate(item)}>Update</button>
                                    </div>
                                )}

                            </div>
                        ))}
                    </>
                ) : (
                    <h3 className=''>Tretment Detail Section</h3>
                )}

                {/* To add next section */}
                <div className='mt-3'>
                    <button className='btn btn-sm btn-primary rounded-2' onClick={AddSection}>Add Section</button>
                </div>
            </div>

            {/* Footer Button */}
            <div className='mt-3 text-center '>
                <Link to='/website-dashboard' className='btn btn-sm btn-default text-red rounded-2  ' >Cancel</Link>
                <button className='btn btn-sm btn-success rounded-2 ml-2 ' onClick={create}>Update</button>
            </div>



        </div >
    )
}
